<template>
  <div class="main-layout">
    <header-layout></header-layout>
    <div>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import headerLayout from '@/components/common/empty-header'

export default {
  components: {
    headerLayout
  },
  data() {
    return {
    }
  }
}
</script>

<style lang="less" scoped>
.main-layout {
  margin-top: calc(70px + var(--kk-spacing-10));
  margin-bottom: var(--kk-spacing-10);
  text-align: left;
}
</style>

